import * as React from 'react'
import createSvgIcon from '../../createSvgIcon'

export default createSvgIcon(
  <>
    <path d='M22 8.99999H17.21L12.82 2.42999C12.42 1.83999 11.55 1.83999 11.16 2.42999L6.77 8.99999H2C1.45 8.99999 1 9.44999 1 9.99999C1 10.09 1.01 10.18 1.04 10.27L3.58 19.54C3.81 20.38 4.58 21 5.5 21H18.5C19.42 21 20.19 20.38 20.43 19.54L22.97 10.27L23 9.99999C23 9.44999 22.55 8.99999 22 8.99999ZM11.99 4.78999L14.8 8.99999H9.18L11.99 4.78999ZM12 17C10.9 17 10 16.1 10 15C10 13.9 10.9 13 12 13C13.1 13 14 13.9 14 15C14 16.1 13.1 17 12 17Z' />
  </>,
  'Categories'
)
